module.exports = __webpack_public_path__ + "static/rowIcon1.519ef534.svg";